import axios from 'core/network/interceptor';
import { GetNotificationSettingsUrl, UpdateNotificationSettingsUrl } from './constants';

const GetNotificationSettingsRequest = async () => {
  const response = await axios.get(GetNotificationSettingsUrl);

  return response.data;
};

interface UpdateNotificationSettingsParams {
  id: number;
  data: {
    new_candidate?: boolean;
    new_application?: boolean;
  }
};

const UpdateNotificationSettingsRequest = async ({ id, data }: UpdateNotificationSettingsParams) : Promise<any>=> {
  const response = await axios.put(UpdateNotificationSettingsUrl(id), data);

  return response.data.offer;
};

export { GetNotificationSettingsRequest, UpdateNotificationSettingsRequest };